import { createElement, FC } from 'react';
import { connect } from 'react-redux';

import type { ReduxState } from 'app/redux/types';

import { LiveStreamComponent } from 'app/modules/LiveStream/constants';
import { selectedStream } from 'app/modules/LiveStream/selectors';

import type { LiveStreamDTO } from '../../types/backend/liveStream';
import HLSHandler from './HLSHandler';
import TwitchHandler from './Twitch/TwitchHandler';
import YouTubeHandler from './YouTubeHandler';

type StoreProps = ReturnType<typeof mapStateToProps>;
type LiveStreamPayload = LiveStreamDTO['payload'];

const COMPONENTS_MAP = {
  [LiveStreamComponent.HLS]:      HLSHandler,
  [LiveStreamComponent.YOUTUBE]:  YouTubeHandler,
  [LiveStreamComponent.TWITCH]:   TwitchHandler,
};

function liveStreamElement(handler: LiveStreamComponent, payload: LiveStreamPayload) {
  const { url, key } = payload;

  if (!(handler in COMPONENTS_MAP)) {
    return null;
  }

  switch (handler) {
    case LiveStreamComponent.HLS:
      if (!url) {
        return null;
      }
      return createElement(COMPONENTS_MAP[handler], { videoId: url });

    case LiveStreamComponent.YOUTUBE:
    case LiveStreamComponent.TWITCH:
      if (!key) {
        return null;
      }
      return createElement(COMPONENTS_MAP[handler], { videoId: key });

    default:
      return null;
  }
}

export const LiveStreamPlayer: FC<StoreProps> = ({ entry }) => {
  if (!entry) {
    return null;
  }

  const { type: handler, payload }  = entry;

  if (handler === null || payload === null) {
    return null;
  }

  return liveStreamElement(handler, payload);
};

const mapStateToProps = (state: ReduxState) => ({
  entry: selectedStream(state),
});

export default connect(mapStateToProps)(LiveStreamPlayer);
